export default {
  home: {
    minute: "minut",
    hour: "sat",
    days: "dana",
    price_info:
      "Prvih {mianfei} minuta je besplatno. Maksimalna naplata za 24 sata je {currencyName}{fengding}. Vaš depozit {currencyName}{yajin} biće automatski vraćen nakon što vratite power bank",
    feature_1: "Uključuje sve vrste kablova: iPhone, Type‑C",
    feature_2: "Može se vratiti na bilo kojoj stanici",
    feature_3: "Dostupno bežično punjenje",
    tips_1:
      "Vaš depozit {currencyName}{yajin} biće vraćen po završetku najma",
    tips_2:
      "Depozit za dopunu {currencyName}{yajin} može se koristiti za najam i, kada se potroši, može se refundirati",
    tips_3:
      "Trenutni balans je {currencyName}{myyue} i može se direktno koristiti za najam",
    submit: "Započni najam",
    borrow: "Iznajmi",
    msg_fail_title: "Greška",
    msg_fail_content: "Najam nije uspeo, pokušajte ponovo",
    msg_rentcount: "Imate {zujieNum} porudžbina koje nisu zatvorene",
    goborrow: "Idi da puniš!!!",
    nearby: "Prikaži obližnje stanice",
    preauth: "Preautorizacija"
  },
  login: {
    code_title: "SMS verifikacija",
    phone_number: "Broj telefona",
    verification_code: "Unesite verifikacioni kod iz SMS‑a",
    captcha_code: "Kod",
    send_code: "Pošalji kod",
    login: "Prijava",
    agree: "Klikom na Prijava, slažete se sa ",
    readme: "Ugovorom o korišćenju",
    msg_fail_login: "Prijava nije uspela",
    msg_success_login: "Uspešna prijava",
    msg_fail_user: "Greška pri dobijanju korisničkih podataka. Želite li da pokušate ponovo?",
    sign_in_with: "Prijavite se pomoću",
    no_sms: "Niste primili SMS",
    retry: "Pošalji ponovo"
  },
  confirm: {
    deletecard: "Obriši karticu",
    addcard: "Unesite podatke kartice",
    title: "Potvrda plaćanja",
    paynow: "Trenutno plaćanje",
    SMSConfirm:
      "Molimo platite prema SMS poruci na telefonu i kliknite na dugme za potvrdu da nastavite.",
    pay_label: "Iznos",
    auth_label: "Preautorizacija",
    price_tips:
      "Balans se može povući na zahtev. Može potrajati 1–5 radnih dana da se pojavi na vašem platnom računu.",
    auth_tips:
      "Preautorizacija u iznosu {0}{1} je obavezna. Stvarni iznos najma biće naplaćen kada se power bank vrati.",
    pay_type: "Izaberite željeni način plaćanja",
    submit: "Potvrdi plaćanje",
    msg_loading: "Učitavanje...",
    msg_fail_title: "Upozorenje",
    msg_fail_payment: "Neuspešno pokretanje plaćanja depozita",
    msg_fail_order: "Neuspešno kreiranje porudžbine za najam",
    msg_fail_support: "Sistem nije podržan",
    msg_fail_confirm: "Potvrdi",
    msg_fail_retry: "Pokušaj ponovo",
    msg_fail_cancel: "Otkaži"
  },
  mine: {
    title: "Korisnički profil",
    wallet: "Moj novčanik",
    balance: "Moj balans",
    deposit: "Depozit",
    wallet_in: "Dopuni",
    wallet_out: "Isplati",
    wallet_log: "Istorija novčanika",
    rental_history: "Istorija najma",
    payment_title: "Načini plaćanja",
    download_app: "Preuzmi aplikaciju",
    settings: "Podešavanja",
    help: "Pomoć",
    logout: "Odjavi se",
    login_tips: "Molimo prijavite se",
    msg_fail_title: "Greška",
    msg_fail_update: "Izmena nije uspela. Pokušajte ponovo",
    msg_loading: "Učitavanje...",
    msg_fail_user: "Greška pri dobijanju korisničkih podataka. Želite li da pokušate ponovo?",
    edit_profile: "Uredi profil",
    join_us: "PRIDRUŽITE NAM SE",
    join_us_details: "Nabavite Cargamos stanicu na vašoj lokaciji"
  },
  msg: {
    appoffline: "Aplikacija još nije pokrenuta, molimo sačekajte",
    deletecard: "Da li ste sigurni da želite da obrišete ovu karticu?",
    no_phone: "Broj telefona je obavezan",
    loading: "Učitavanje...",
    title: "Savet",
    success: "Operacija uspešna",
    error: "Nepoznata greška. Pokušajte kasnije",
    roleerror: "Nedovoljna ovlašćenja. Obratite se administratoru.",
    neterror: "Mrežna veza nije uspela. Pokušajte kasnije",
    confirm: "Potvrdi",
    retry: "Pokušaj ponovo",
    cancel: "Otkaži",
    title_fail: "Upozorenje",
    vieworder: "Pogledaj porudžbinu",
    success_payment: "Plaćanje završeno",
    success_buy: "Kupovina završena",
    fail_payment: "Neuspešno plaćanje",
    keyword: "Ključna reč",
    ispayorder: "Potvrdite da je plaćanje izvršeno",
    unpay: "Neplaćeno",
    yespay: "Plaćeno",
    notopen: "Još nije otvoreno"
  },
  result: {
    tips:
      "Da biste videli porudžbine i druge lokacije stanica, preuzmite aplikaciju.",
    download: "Preuzmi aplikaciju",
    title: "Najam potvrđen",
    gotit: "Razumem",
    price_plan: "Cenovnik",
    msg_success: "Najam uspešno",
    msg_tips_loading: "Power bank se izdaje, molimo sačekajte...",
    msg_result_loading: "Potvrđuje se rezultat plaćanja...",
    msg_fail_confirm: "Potvrdi",
    btn_usage: "Uputstvo za upotrebu",
    btn_return: "Uputstvo za vraćanje",
    deposit: "Depozit",
    msg_fail_content: "Zahtev nije uspeo. Pokušajte ponovo.",
    price_label: "po satu",
    price_info:
      "Prvih {mianfei} minuta besplatno, maksimalna dnevna naplata {ccurrency}{fengding}. Depozit će biti automatski odbijen kada najam dostigne {ccurrency}{yajin}",
    tips_1: "Molimo preuzmite power bank br. {number} kao na slici",
    tips_2:
      "Molimo uredno složite kablove i ubacite power bank u slot sa stranom označenom [strelicama nadole]",
    msg_note_usage:
      "Power bank ima 3 vrste kablova, izaberite onaj koji vam odgovara.",
    msg_note_return:
      "Molimo uredno složite kablove i ubacite power bank u slot sa stranom označenom [strelicama nadole]",
    return_info:
      "Pri vraćanju, uverite se da su kablovi uredno složeni i ubacite stranu sa metalnim kontaktima u slobodan ležište do kraja.",
    download_tips:
      "Za iznajmljivanje našeg powerbanka možete izabrati jednu od sledećih opcija"
  },
  result_msg: {
    loading: "Učitavanje...",
    refresh: "Osveži"
  },
  order: {
    title: "Istorija najma",
    in_use: "U upotrebi",
    ended: "Završeno",
    msg_error: "Zahtev nije uspeo",
    order_number: "Br.",
    order_details: "Detalji porudžbine",
    order_zj_shop: "Mesto iznajmljivanja",
    order_zj_time: "Vreme iznajmljivanja",
    order_gh_shop: "Mesto vraćanja",
    order_gh_time: "Vreme vraćanja",
    order_use_time: "Vreme korišćenja",
    order_amount: "Ukupan iznos",
    not_on_rent: "Nije u najmu",
    renting: "U najmu",
    undone: "Nije završeno",
    returned: "Vraćeno",
    questions: "Pitanja",
    timeout_to_return: "Istek roka za vraćanje",
    suspended_for_billing: "Suspendovano za obračun"
  },
  order_item: {
    order_number: "Br.",
    venue_rented: "Mesto preuzimanja",
    time_rented: "Vreme preuzimanja",
    venue_returned: "Mesto vraćanja",
    time_returned: "Vreme vraćanja",
    charge_standard: "Tarifa",
    charge_standard_info:
      "{pJifei} {pCurrency} po satu (prvih {pMian} min besplatno)",
    rent_occurred: "Najam ostvaren",
    returned: "Vraćeno",
    unreturned: "Nije vraćeno",
    type_0: "Nije završeno",
    type_1: "U najmu",
    type_2: "Otkazano",
    type_3: "Vraćeno",
    type_4: "Došlo je do greške",
    type_5: "Prekoračenje",
    min: "min",
    payment: "Plaćanje"
  },
  setting: {
    title: "Podešavanja",
    lang: "Jezik"
  },
  help: {
    title: "Česta pitanja",
    rentals: "Najmovi",
    venues: "Lokacije",
    payments: "Plaćanja"
  },
  wallet_in: {
    title: "Dopuna balansa",
    price_label: "Iznos dopune",
    price_placeholder: "Unesite iznos dopune",
    balance: "Trenutni balans",
    price_auto: "Izaberite iznos plaćanja",
    price_tips:
      "Balans se može povući na zahtev. Može potrajati 1–5 radnih dana da se pojavi na vašem platnom računu.",
    submit: "Pošalji",
    loading: "Učitavanje...",
    paying: "Preusmeravanje na stranicu za plaćanje...",
    msg_title: "Saveti",
    msg_fail_order: "Neuspešno kreiranje porudžbine za dopunu",
    msg_fail_payment: "Neuspešno pokretanje plaćanja dopune",
    msg_fail_retry: "Pokušaj ponovo"
  },
  wallet_out: {
    title: "Isplata",
    price_label: "Iznos isplate",
    price_placeholder: "Unesite iznos isplate",
    balance: "Trenutni balans",
    balance_all: "Isplati sve",
    deposit: "Depozit",
    deposit_tips:
      "Postoji nezavršena porudžbina najma. Depozit Ksh{pyajin} nije povratan",
    submit: "Pošalji",
    apply: "Primeni",
    confirm: "Potvrdi",
    loading: "Učitavanje...",
    msg_fail_price: "Iznos isplate je neispravan",
    msg_fail_balance: "Iznos isplate ne može biti veći od trenutnog balansa",
    msg_fail_submit: "Molimo popunite sva obavezna polja",
    msg_title: "Greška",
    msg_success_content: "Povraćaj uspešan",
    confirmtitle: "Saveti",
    confirmcontent:
      "Trenutni novčanik ne podržava isplatu gotovine. Molimo ostavite kontakt podatke za ručnu obradu povraćaja",
    payee_name: "Ime primaoca",
    payee_bankcard: "Broj bankovne kartice",
    payee_phone: "Telefon",
    cancelText: "Otkaži",
    confirmText: "Ponovo podnesi"
  },
  map: {
    在线: "Otvoreno",
    离线: "Zatvoreno",
    title: "Obližnja stanica",
    result_msg: "Nije pronađena nijedna stanica u blizini",
    msg_title: "greška",
    no_support: "Žao nam je! Vaš pregledač ne podržava usluge lokacije",
    my_position: "Moja lokacija",
    distance: "Udaljenost:",
    shop_time: "Radno vreme",
    free: "Dostupno za najam",
    return: "Dostupna prazna mesta",
    shop_title: "Detalji lokacije",
    address: "Adresa",
    go_here: "Idi ovde",
    nav_help: "Pomoć",
    nav_search: "Pretraga"
  },
  scanQr: {
    NotAllowedError: "Potrebno je odobriti pristup kameri",
    NotFoundError: "Nema kamere na ovom uređaju",
    NotSupportedError: "Potreban je bezbedan kontekst (HTTPS, localhost)",
    NotReadableError: "Kamera je zauzeta",
    OverconstrainedError: "Postavke kamere nisu odgovarajuće",
    StreamApiNotSupportedError:
      "Ovaj pregledač ne podržava streaming API"
  },
  payment: {
    payment_title: "Načini plaćanja",
    pay_type: "Dodajte podatke kartice",
    add_payment_card: "Dodaj platnu karticu",
    add_payment: "dodaj plaćanje"
  },
  shop: {
    title: "Obližnja stanica",
    search_station: "Pretraži stanicu",
    search_station_tips: "Unesite naziv stanice",
    shop_power_banks: "Power bankovi",
    shop_empty_slots: "Prazni slotovi",
    shop_address: "Adresa",
    shop_business_hours: "Radno vreme",
    shop_directions_station: "Uputstvo do stanice",
    shop_scan_qrcode: "Skeniraj QR"
  },
  paymethod: {
    payamount: "Iznos za plaćanje",
    choosepaymethod: "Izaberite opcije plaćanja",
    addcard: "Dodaj novu karticu",
    confrimpay: "Potvrdi plaćanje",
    借记卡: "Debitna kartica",
    银行卡列表: "Lista bankovnih kartica"
  },
  orderDetail: {
    price1: "{pJifei} {pCurrencyName} po {pJifeiDanwei} {priceUnit}",
    price2: "Do {pFengding} {pCurrencyName} za 24 sata",
    price3: "Naknada za nevraćanje {overtimeAmount} {pCurrencyName}",
    venuerented: "Mesto iznajmljivanja",
    venuereturned: "Mesto vraćanja",
    timerented: "Vreme iznajmljivanja",
    timereturned: "Vreme vraćanja",
    powerbankid: "ID power banka",
    getreceipt: "PREUZMI RAČUN",
    buypowerbank: "Kupi ovaj power bank",
    usetime: "Vreme korišćenja",
    estimatedamount: "Procenjeni iznos",
    feerule: "Pravila naplate",
    payment: "Plaćanje",
    orderNo: "Br. porudžbine",
    trafficDetails: "Pogledaj detalje saobraćaja paketa",
    Renewals: "Obnove",
    FeeSchedule: "Cenovnik",
    HowToUse: "Kako koristiti",
    LeaseMerchant: "Iznajmljivač",
    startTime: "Vreme početka",
    ReturningMerchants: "Mesta vraćanja",
    EndTime: "Vreme završetka",
    Deposit: "Depozit",
    fee1: "Depozit opreme {overtimeAmount} {pCurrencyName}",
    fee2:
      "Vraćeno u roku od {overtime} dana nakon isteka najma, umanjeno za {pFengding} {pCurrencyName} po 24 sata.",
    fee3:
      "Ako se oprema vrati u roku od {overtime} dana nakon isteka perioda najma, odbiće se {overtimeAmount} {pCurrencyName}.",
    fee4:
      "Depozit će biti automatski odbijen ako se oprema ne vrati više od 15 dana nakon isteka dana najma.",
    rentagain: "Iznajmi ponovo",
    onrental: "U najmu",
    revoked: "Opozvano",
    returned: "Vraćeno",
    issue: "Problem",
    overtimereturn: "Istek roka"
  },
  selectpackage: {
    powerbank: "Power bank",
    powerstation: "Stanica",
    wifibox: "Wi‑Fi kutija",
    choosepackage: "Izaberite paket saobraćaja",
    minute: "minut",
    首次免费: "Besplatno prvih ",
    最大每日收费: "Maksimalna dnevna naplata ",
    devicedeposit: "Depozit za uređaj",
    return_will_back: "Vratite depozit nakon vraćanja uređaja",
    lengthofuse: "Vreme korišćenja",
    amountcharged: "Akumulirani iznos",
    release_powerbank: "Oslobodite svoj power bank",
    see_pricing: "Pogledaj cene",
    deposit: "depozit",
    agreen: "Nastavljanjem se slažete sa našom ",
    privacy_policy: "Politikom privatnosti",
    and: " i ",
    terms_and_conditions: "Uslovima korišćenja.",
    per: "po"
  },
  rentcost: {
    rentcosttitle: "Koliko košta najam?",
    price1: "{currency} {jifei} po {jifeiDanwei} {priceUnit}",
    price2: "{currency} {fengding} po danu",
    tip1:
      "Ako ne vratite power bank u roku od {overtime} dana, biće vam naplaćeno {overtimeAmount} {currency} i ne morate da ga vratite.",
    tip2: "Jedan dan najma je 24 sata od trenutka preuzimanja power banka.",
    tip3:
      "Naplaćujemo {yajin} {currency} kao sigurnosni depozit koji se vraća kada se baterija vrati na stanicu.",
    tip4: "Neke lokacije mogu nuditi besplatne sate ili popuste. Uživajte!",
    Days: "Dani",
    Hours: "Sati",
    Minutes: "Minuti",
    free: "{mianfei} minuta besplatno",
    willcharged: "Biće vam naplaćeno {currency} {money}"
  }
};
